import React from "react";
import { Pagination } from "../Common/TableComponent/Pagination";
import MediaLibraryPageSizeSelect from "./MediaLibraryPageSizeSelect";

/**
 * Shared footer for Media Library grids — page size selector + pagination.
 */
const MediaLibraryPaginationBar = ({
  currentPage,
  totalPages,
  totalEntries,
  pageSize,
  onPageChange,
  onPageSizeChange,
  showPageSize = true,
  className = "",
}) => {
  if (totalEntries <= 0) return null;
  if (!showPageSize && totalPages <= 1) return null;

  return (
    <div className={`xc-ml-pagination-bar ${className}`.trim()}>
      {showPageSize ? (
        <MediaLibraryPageSizeSelect
          value={pageSize}
          onChange={onPageSizeChange}
        />
      ) : null}
      {totalPages > 1 ? (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          totalEntries={totalEntries}
          entriesPerPage={pageSize}
        />
      ) : null}
    </div>
  );
};

export default MediaLibraryPaginationBar;
